import BaseTool from "../../baseComponents/BaseTool";
import SliceWidget from "./SliceWidget";
import PointWidget from "./PointWidget";
import ViewWidget from "./ViewWidget";
import {memo} from "react";
import {deepClone} from "@mui/x-data-grid/internals";


const PARAM_SCHEMA = {
  plot_widget: {},
  sim_widget: {},
  slice_widget: {},
  point_widget: {},
  view_widget: {},
}

const DEFAULTS= {
  sim_widget: {
    domain: 'cor',
    data_product: 'chmap',
    time_of_interest: null,
  },
  slice_widget: {
    slice: 'r',
    slice_param1: null,
    abs_transform: false,
    log_transform: false,
    rad_transform: true,
    rad_transform_exponent: 2,
    units: 'real',
    show_text: true,
    color: 'psi_blue_gray_red'
  },
  point_widget: {
    query_point: false,
    point_xvalue: null,
    point_yvalue: null,
    line_width: 0.8,
    line_style: 'dashed',
    marker_symbol: 'o',
    color: '#A2000B',
    show_point: true,
    show_lines: true,
    show_text: true,
  },
  view_widget: {
    xaxis_min: null,
    xaxis_max: null,
    xaxis_ticks: null,
    yaxis_min: null,
    yaxis_max: null,
    yaxis_ticks: null,
    zaxis_min: null,
    zaxis_max: null,
    zaxis_ticks: null,
    symmetric: true,
    symmetric_value: null,
    grid: null,
  },
}

const sharedData = {
  sim_widget: {data_product: null},
}

const flagTriggers = {
  sim_widget: {data_product: true},
}

const flagValidators = (widget, k, v, dependencies) => {
  let modifiedParams = deepClone(PARAM_SCHEMA);
  modifiedParams.sim_widget.data_product = 'chmap';
  modifiedParams.slice_widget.color = 'psi_blue_gray_red';
  return { widget_: "_", params_: modifiedParams };
};

const DataProducts = ({id, setId}) => {
  return (
    <>
      <BaseTool
        id={id}
        setId={setId}
        tool='data_products'
        toolName='DATA PRODUCTS'
        sharedDeps={sharedData}
        flagTriggers={flagTriggers}
        flagValidators={flagValidators}
        defaults={DEFAULTS}
        sliceWidget={SliceWidget}
        pointWidget={PointWidget}
        viewWidget={ViewWidget}
      />
    </>

  )
}

export default memo(DataProducts);